import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const PageCollectionIcon: React.ComponentType<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 214 102">
    <svg fill="none">
      <path fill="#F9FBFD" d="M0 0h214v102H0z" />
      <rect
        opacity={0.4}
        x={13}
        y={53}
        width={80}
        height={32}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={38}
        y={63}
        width={45}
        height={4}
        rx={2}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={38}
        y={72}
        width={29}
        height={4}
        rx={2}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <circle opacity={0.4} cx={27} cy={69} r={8} fill="#2962FF" fillOpacity={0.3} />
      <rect
        opacity={0.4}
        x={101}
        y={53}
        width={80}
        height={32}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={126}
        y={63}
        width={45}
        height={4}
        rx={2}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={126}
        y={72}
        width={29}
        height={4}
        rx={2}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <circle opacity={0.4} cx={115} cy={69} r={8} fill="#2962FF" fillOpacity={0.3} />
      <path fill="#000" fillOpacity={0.12} d="M13 45h190v1H13z" />
      <rect
        opacity={0.4}
        x={12}
        y={20}
        width={80}
        height={13}
        rx={6.5}
        fill="#2962FF"
        fillOpacity={0.3}
      />
    </svg>
  </SvgIcon>
);

export default PageCollectionIcon;
